import { geoEquirectangular, geoPath } from "d3-geo";

function swapToLngLat(ring: number[][]): number[][] {
  return ring.map(([a, b]) => [b, a]);
}

function ringToPolygonFeature(ring: number[][]): GeoJSON.Polygon {
  const closed =
    ring.length > 1 &&
    ring[0][0] === ring[ring.length - 1][0] &&
    ring[0][1] === ring[ring.length - 1][1]
      ? ring
      : [...ring, ring[0]];
  return {
    type: "Polygon",
    coordinates: [closed],
  };
}

function manualRingToSvgPath(
  ring: number[][],
  width: number,
  height: number,
  padding: number,
): string {
  let minLng = ring[0][0];
  let maxLng = ring[0][0];
  let minLat = ring[0][1];
  let maxLat = ring[0][1];

  for (const [lng, lat] of ring) {
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
  }

  const lngSpan = maxLng - minLng || 1;
  const latSpan = maxLat - minLat || 1;
  const innerW = width - padding * 2;
  const innerH = height - padding * 2;

  const points = ring.map(([lng, lat]) => {
    const xNorm = (lng - minLng) / lngSpan;
    const yNorm = (lat - minLat) / latSpan;
    const x = padding + xNorm * innerW;
    const y = padding + (1 - yNorm) * innerH;
    return `${x},${y}`;
  });

  if (points.length === 0) return "";
  return `M ${points[0]} L ${points.slice(1).join(" L ")} Z`;
}

export function geojsonRingToSvgPath(
  coordinates: number[][],
  width: number,
  height: number,
  padding = 4,
  swapLatLng = false,
  useManualFit = true,
): string {
  if (!coordinates || coordinates.length === 0) return "";

  const ring = swapLatLng ? swapToLngLat(coordinates) : coordinates;

  if (useManualFit) {
    return manualRingToSvgPath(ring, width, height, padding);
  }

  const feature = ringToPolygonFeature(ring);
  const innerWidth = width - padding * 2;
  const innerHeight = height - padding * 2;

  const projection = geoEquirectangular().fitSize(
    [innerWidth, innerHeight],
    feature,
  );
  const pathGenerator = geoPath(projection);
  const svgPathD = pathGenerator(feature);

  return svgPathD ?? "";
}
